import { render, staticRenderFns } from "./ItemsGroupFaces.vue?vue&type=template&id=3e8080b5"
import script from "./ItemsGroupFaces.vue?vue&type=script&lang=js"
export * from "./ItemsGroupFaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports